import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {MdbCheckboxModule} from "mdb-angular-ui-kit/checkbox";
import {AbstractControl, FormGroup, ReactiveFormsModule} from "@angular/forms";

import {MdbFormsModule} from "mdb-angular-ui-kit/forms";
import {MdbValidationModule} from "mdb-angular-ui-kit/validation";
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'app-checkbox-input',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    MdbCheckboxModule,
    ReactiveFormsModule,
    MdbFormsModule,
    MdbValidationModule,
    TranslateModule
],
    templateUrl: './checkbox-input.component.html',
    standalone: true,
    styleUrl: './checkbox-input.component.scss'
})
export class CheckboxInputComponent {
  @Input({required: true}) id!: string;
  @Input({required: true}) label!: string;
  @Input({required: true}) controlName!: string;
  @Input({required: true}) formGroup!: FormGroup;
  @Input() isRequiredTrue: boolean = false;
  @Input() checked: boolean = false;

  get control(): AbstractControl | null {
    return this.formGroup!.get(this.controlName!)
  }
}
